import { XMarkIcon } from '@heroicons/react/24/outline';
import { useEscapeKey } from '../../../../../hooks/useEscapeKey';

interface DeleteDraftConfirmModalProps {
    onCancel: () => void;
    onConfirm: () => void;
}

/**
 * Lightweight "are you sure?" prompt for discarding an in-progress Dx
 * draft. The actual delete request fires from the parent's handler.
 */
export function DeleteDraftConfirmModal({ onCancel, onConfirm }: DeleteDraftConfirmModalProps) {
    useEscapeKey(onCancel, true);
    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex justify-center items-center">
            <div className="bg-white rounded-lg shadow-xl w-full max-w-[520px] p-6 relative">
                <div className="flex justify-between items-center mb-4">
                    <h2 className="text-xl font-bold text-gray-900">Delete this draft?</h2>
                    <button
                        onClick={onCancel}
                        className="text-gray-400 hover:text-gray-800"
                        aria-label="Close"
                    >
                        <XMarkIcon className="w-5 h-5" />
                    </button>
                </div>
                <p className="text-sm text-gray-600 mb-4">This cannot be undone.</p>
                <div className="flex justify-end items-center gap-3 mt-6">
                    <button
                        onClick={onCancel}
                        className="bg-white text-gray-800 border border-gray-300 px-4 py-2 rounded-lg hover:bg-gray-50 transition-colors font-semibold text-sm"
                    >
                        Cancel
                    </button>
                    <button
                        onClick={onConfirm}
                        className="flex items-center gap-2 bg-red-600 text-white rounded-lg px-4 py-2 text-sm font-semibold hover:bg-red-700 transition-colors"
                    >
                        Delete draft
                    </button>
                </div>
            </div>
        </div>
    );
}
